import Vue from "vue";
import moment from "moment";
import { toTimestamp } from "../util/firestore_util";

Vue.filter("moment", function (timestamp, format) {
  return moment(timestamp.toDate()).format(format);
});

Vue.filter("momentJS", function (timestampJS, format) {
  const timestamp = toTimestamp(timestampJS);
  return moment(timestamp.toDate()).format(format);
});

Vue.filter("YYYYMMDDHHMM", function (timestamp) {
  const format = "YYYY/MM/DD hh:mm";
  return moment(timestamp.toDate()).format(format);
});
